/* LD · Secciones estilo ADOR */
(function () {
  class LdAdorSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ldA-slideshow__track');
      this.slides = Array.from(this.querySelectorAll('.ldA-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.ldA-dot'));
      this.index = 0;
      this.paused = false;
      if (!this.track || this.slides.length < 2) return;
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      this.pauseBtn = this.querySelector('[data-pause]');
      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', () => {
          this.paused = !this.paused;
          this.pauseBtn.classList.toggle('is-paused', this.paused);
          if (this.paused) this.stop();
          else this.start();
        });
      }
      let t;
      this.track.addEventListener(
        'scroll',
        () => {
          clearTimeout(t);
          t = setTimeout(() => this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)), 80);
        },
        { passive: true }
      );
      /* Como ADOR: se detiene con el ratón encima o con el foco dentro, y sigue al salir */
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => {
        if (!this.paused) this.start();
      });
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => {
        if (!this.paused) this.start();
      });
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    setActive(i) {
      this.index = i;
      this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
    }

    go(i, user) {
      const n = this.slides.length;
      i = (i + n) % n;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.setActive(i);
      if (user && !this.paused) this.start();
    }

    start() {
      this.stop();
      if (this.dataset.autoplay !== 'true') return;
      /* Como ADOR: cambia cada «speed» segundos (ajuste de la sección) */
      const speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.timer = setInterval(() => this.go(this.index + 1), speed);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('ld-ador-slideshow')) customElements.define('ld-ador-slideshow', LdAdorSlideshow);

  function initVideos() {
    const videos = document.querySelectorAll('.ldA-vid video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.play().catch(() => {});
          else entry.target.pause();
        });
      },
      { threshold: 0.4 }
    );
    videos.forEach((video) => io.observe(video));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideos);
  else initVideos();
  document.addEventListener('shopify:section:load', initVideos);
})();

/* Portada: títulos y tarjetas aparecen al hacer scroll (una sola vez).
   Lo que ya se ve al cargar no se toca; si se baja muy rápido, aparece al momento.
   Valores en ld-motion.css, sección 14. */
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const path = location.pathname.replace(/\/$/, '');
  if (path !== root.replace(/\/$/, '')) return;
  if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) return;

  function reveal(entries, io) {
    const vh = window.innerHeight;
    const shown = entries.filter((entry) => entry.isIntersecting);
    shown.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left);
    let step = 0;
    shown.forEach((entry) => {
      const el = entry.target;
      io.unobserve(el);
      /* Se ha saltado hasta aquí (scroll muy rápido o ancla): sin esperas */
      if (entry.boundingClientRect.top < vh * 0.5) el.classList.add('is-now');
      else if (!el.classList.contains('ldA-h2')) el.style.setProperty('--ld-rv-i', Math.min(step++, 3));
      el.classList.add('is-in');
      setTimeout(() => {
        el.classList.remove('ld-rv', 'is-in', 'is-now');
        el.style.removeProperty('--ld-rv-i');
      }, 800);
    });
  }

  function init() {
    const limit = window.innerHeight * 0.9;
    const items = Array.from(document.querySelectorAll('#MainContent .ldA-h2, #MainContent .ldA-grid > li'))
      .filter((el) => !el.classList.contains('ld-rv') && el.getBoundingClientRect().top > limit);
    if (!items.length) return;
    items.forEach((el) => el.classList.add('ld-rv'));
    const io = new IntersectionObserver(reveal, { rootMargin: '0px 0px -10% 0px' });
    items.forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
